import { Key } from '@briebug/ngrx-auto-entity';

export class RestorationVendor {
  @Key id?: number;
  vendor: string;
  vendorName?: string;
  categories: number[];
}
